import { Link } from 'react-router-dom';

/**
 * Sprint BG-Menu (第 3 段): 地区サブページ共通ヘッダー。
 *
 * 「← 地区詳細」リンク + 地区名 + secondary tab nav (overview / display / ai / misc /
 * data-settings) を 1 行で表示する。各 sub-page (Display / AiSettings / Misc) で共通利用。
 */

interface Tab {
  to: string;
  label: string;
}

export interface DistrictSubPageHeaderProps {
  districtId: string;
  districtName: string;
  /** active な tab のリンク先 (完全一致比較)。 */
  activeTo: string;
}

export function DistrictSubPageHeader({
  districtId,
  districtName,
  activeTo,
}: DistrictSubPageHeaderProps) {
  const base = `/districts/${districtId}`;
  const tabs: Tab[] = [
    { to: base, label: '概要' },
    { to: `${base}/display`, label: '地図・表示の設定' },
    { to: `${base}/ai`, label: 'AI 設定' },
    { to: `${base}/misc`, label: 'その他設定' },
    { to: `${base}/data-settings`, label: '入力項目' },
  ];

  return (
    <header className="mb-6">
      <div className="flex items-center gap-3">
        <Link to={base} className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
          ← 地区詳細
        </Link>
        <Link
          to="/help"
          className="text-sm text-primary-600 hover:text-primary-700 hover:underline"
        >
          ？ 使い方
        </Link>
      </div>
      <h1 className="text-2xl font-bold text-slate-900 mt-2">{districtName}</h1>
      <nav
        className="mt-3 flex flex-wrap gap-1 border-b border-slate-200"
        aria-label="地区サブページ"
      >
        {tabs.map((t) => {
          const active = t.to === activeTo;
          return (
            <Link
              key={t.to}
              to={t.to}
              aria-current={active ? 'page' : undefined}
              className={`
                px-3 py-2 text-sm rounded-t-md border-b-2 -mb-px transition-colors
                ${
                  active
                    ? 'border-primary-600 text-primary-700 font-semibold'
                    : 'border-transparent text-slate-600 hover:text-primary-700'
                }
              `}
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}
